/**
 * @format
 */
import { Injectable } from "@angular/core";
import { createAction, props } from "@ngrx/store";

@Injectable()
export class EditorActions {
   static undoChange = createAction("[EditorTemplate] Undo changes");
   static redoChange = createAction("[EditorTemplate] Redo changes");
   static updateHistory = createAction(
      "[EditorTemplate] Update History",
      props<{
         previousValue: string;
         currentValue: string;
         updateModelVariable: string;
      }>()
   );
   static updateHistoryForDifferentVariable = createAction(
      "[EditorTemplate] Update History for Different Variable",
      props<{
         previousValue: string;
         currentValue: string;
         updateModelVariable: string;
      }>()
   );
   static resetHistory = createAction("[EditorTemplate] Reset History");
   static updateWindowSelectionTimestamp = createAction(
      "[EditorTemplate] Update Window Selection Timestamp",
      props<{ timestamp: number }>()
   );
   static resetWindowSelectionCounter = createAction("[EditorTemplate] Reset Window Selection Timestamp");
}
